import { Switch, Route, Redirect, useRouteMatch } from 'peach/router'

import AppDomain from './AppDomain'
import AppDomains from './AppDomains'
import CreateAppDomain from './CreateAppDomain'

const AppDomainsRoutes = () => {
  const { path, url } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path}>
        <AppDomains />
      </Route>

      <Route path={`${path}/create`}>
        <CreateAppDomain />
      </Route>

      <Route path={`${path}/:appDomainId`}>
        <AppDomain />
      </Route>

      <Redirect to={url} />
    </Switch>
  )
}

export default AppDomainsRoutes
